import { render, staticRenderFns } from "./PrescriptionPad.vue?vue&type=template&id=786c5981"
import script from "./PrescriptionPad.vue?vue&type=script&lang=js"
export * from "./PrescriptionPad.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionPad.vue?vue&type=style&index=0&id=786c5981&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports